        document.addEventListener('DOMContentLoaded', function() {
            // Position the markers
            const markers = document.querySelectorAll('.feature-marker');
            markers.forEach(marker => {
                const x = marker.getAttribute('data-x');
                const y = marker.getAttribute('data-y');
                marker.style.left = `${x}%`;
                marker.style.top = `${y}%`;
            });

            // Add hover interactions
            function handleHover(element, isEntering) {
                const featureId = element.getAttribute('data-feature-id');
                const marker = document.querySelector(`.feature-marker[data-feature-id="${featureId}"]`);
                const featureItem = document.querySelector(`.feature-item[data-feature-id="${featureId}"]`);
                
                if (isEntering) {
                    marker.classList.add('highlight');
                    featureItem.classList.add('highlight');
                } else {
                    marker.classList.remove('highlight');
                    featureItem.classList.remove('highlight');
                }
            }

            // Add event listeners to markers
            markers.forEach(marker => {
                marker.addEventListener('mouseenter', () => handleHover(marker, true));
                marker.addEventListener('mouseleave', () => handleHover(marker, false));
            });

            // Add event listeners to feature items
            const featureItems = document.querySelectorAll('.feature-item');
            featureItems.forEach(item => {
                item.addEventListener('mouseenter', () => handleHover(item, true));
                item.addEventListener('mouseleave', () => handleHover(item, false));
            });
        });